export default "__VITE_ASSET__BvVyvDdP__"